import { render, staticRenderFns } from "./loadingComponent.vue?vue&type=template&id=1636743c"
import script from "./loadingComponent.ts?vue&type=script&lang=js&external"
export * from "./loadingComponent.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1636743c')) {
      api.createRecord('1636743c', component.options)
    } else {
      api.reload('1636743c', component.options)
    }
    module.hot.accept("./loadingComponent.vue?vue&type=template&id=1636743c", function () {
      api.rerender('1636743c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/loadingComponent/loadingComponent.vue"
export default component.exports